export default function TrustCards() {
  const cards = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет опыта в продажах и обучении' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов реализовано' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов проведено' },
    { icon: 'ri-user-star-line', value: '4 500+', label: 'участников прошли обучение' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {cards.map((card, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-7 text-center hover:bg-teal-50 transition-colors duration-300">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                <i className={`${card.icon} text-xl text-teal-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-1">{card.value}</div>
              <div className="text-xs md:text-sm text-gray-600 leading-snug">{card.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}